import { render, staticRenderFns } from "./formGenerator.vue?vue&type=template&id=5f902cca&lang=pug&"
import script from "./formGenerator.vue?vue&type=script&lang=js&"
export * from "./formGenerator.vue?vue&type=script&lang=js&"
import style0 from "./formGenerator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports